import { render, staticRenderFns } from "./s-presentation-identite.vue?vue&type=template&id=120d45d0&scoped=true"
var script = {}
import style0 from "./s-presentation-identite.vue?vue&type=style&index=0&id=120d45d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120d45d0",
  null
  
)

export default component.exports